import { cartTotalStyles } from "@insite/content-library/Widgets/Cart/CartTotal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import get from "@insite/mobius/utilities/get";
import { css } from "styled-components";

cartTotalStyles.checkoutButton = {
    mergeCss:true,
    css: css`
        span {
            color: #FFFFFF;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        // position: fixed;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        z-index: ${get(theme, "zIndex.stickyFooter")};
                    `,
                    css`
                        width: 100%;
                        margin-top: 10px;
                        position: inherit;
                        left: inherit;
                        bottom: inherit;
                    `,
                ],
                "min",
            )}
    `,
}

cartTotalStyles.cancelPunchOutButton = {
    mergeCss: true,
    buttonType: "outline",
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
}
cartTotalStyles.submitQuoteButton = {
    mergeCss: true,
    buttonType: "outline",
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
}
cartTotalStyles.saveOrderButton = {
    mergeCss: true,
    buttonType: "outline",
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
}
cartTotalStyles.submitRequisitionButton = {
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
}